"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CloseSquare_1 = require("@styled-icons/evaicons-solid/CloseSquare");
var moment_1 = __importDefault(require("moment"));
var JStorage = __importStar(require("../../../Actions/JStorage"));
function Coupon(props) {
  var _this = this;
  var privateProfile = props.privateProfile,
    usedCoupon = props.usedCoupon,
    onUseCoupon = props.onUseCoupon;
  var _a = react_1.default.useState(''),
    selectedCoupon = _a[0],
    setSelectedCoupon = _a[1];
  var _b = react_1.default.useState([]),
    couponCanUse = _b[0],
    setCouponCanUse = _b[1];
  var _c = react_1.default.useState(''),
    inputCoupon = _c[0],
    setInputCoupon = _c[1];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var handleCouponCodeChange = function handleCouponCodeChange(value) {
    setInputCoupon(value);
  };
  var handleCouponUse = function handleCouponUse(coupon) {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            AppActions.setLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, onUseCoupon(coupon)];
          case 2:
            _a.sent();
            setInputCoupon('');
            setSelectedCoupon('');
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _a.sent();
            if (ex_1 === null || ex_1 === void 0 ? void 0 : ex_1.response) {
              if (ex_1.response.error === 'invalid_coupon') {
                antd_1.message.error('不合法的優惠券');
              }
              if (ex_1.response.error === 'below_threshold') {
                antd_1.message.error('總金額低於可使用門檻');
              }
              if (ex_1.response.error === 'usage_exceed') {
                antd_1.message.error('優惠券數量不足');
              }
            }
            return [3 /*break*/, 4];
          case 4:
            AppActions.setLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  react_1.default.useEffect(function () {
    var _fetchCoupons = function _fetchCoupons() {
      return __awaiter(_this, void 0, void 0, function () {
        var now, _global, _personal, err_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              now = new Date().getTime();
              _a.label = 1;
            case 1:
              _a.trys.push([1, 4,, 5]);
              return [4 /*yield*/, JStorage.fetchAllDocuments('coupon', {
                type: 'global',
                start_time: {
                  $lte: now
                },
                end_time: {
                  $gte: now
                },
                is_void: false
              })];
            case 2:
              _global = _a.sent();
              return [4 /*yield*/, JStorage.fetchAllDocuments('coupon', {
                type: 'personal',
                user_id: privateProfile === null || privateProfile === void 0 ? void 0 : privateProfile.owner,
                start_time: {
                  $lte: now
                },
                end_time: {
                  $gte: now
                },
                is_void: false
              })];
            case 3:
              _personal = _a.sent();
              setCouponCanUse(__spreadArray(__spreadArray([], _global), _personal));
              return [3 /*break*/, 5];
            case 4:
              err_1 = _a.sent();
              console.warn(err_1);
              antd_1.message.error('無法取得 coupon 資料');
              return [3 /*break*/, 5];
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };

    _fetchCoupons();
  }, [privateProfile]);
  var handleDiscardCoupon = function handleDiscardCoupon(e) {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        e.stopPropagation();
        handleCouponUse('');
        return [2 /*return*/];
      });
    });
  };

  return react_1.default.createElement("div", null, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, react_1.default.createElement(antd_1.Select, {
    style: {
      flex: 1
    },
    value: selectedCoupon,
    onChange: function onChange(value) {
      setSelectedCoupon(value);
    },
    placeholder: "\u8ACB\u9078\u64C7\u5C08\u5C6C\u512A\u60E0\u5238\u4EE3\u78BC"
  }, react_1.default.createElement(antd_1.Select.Option, {
    key: -1,
    value: ""
  }, "\u9078\u64C7\u5C08\u5C6C\u512A\u60E0\u5238"), couponCanUse.map(function (_coupon, index) {
    return react_1.default.createElement(antd_1.Select.Option, {
      key: index,
      value: _coupon.code
    }, _coupon.name);
  })), react_1.default.createElement(antd_1.Button, {
    style: {
      margin: '10px 0'
    },
    htmlType: "button",
    type: "primary",
    onClick: function onClick() {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, handleCouponUse(selectedCoupon)];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    }
  }, "\u4F7F\u7528")), react_1.default.createElement(antd_1.Input.Search, {
    style: {
      width: '100%'
    },
    placeholder: "\u8F38\u5165\u512A\u60E0\u5238\u4EE3\u78BC",
    value: inputCoupon,
    onChange: function onChange(e) {
      handleCouponCodeChange(e.target.value);
    },
    onSearch: function onSearch(_coupon) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, handleCouponUse(_coupon)];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    },

    enterButton: true
  })), usedCoupon && react_1.default.createElement(antd_1.Badge.Ribbon, {
    color: "red",
    text: react_1.default.createElement(StyledRibbonInner, {
      onClick: handleDiscardCoupon
    }, react_1.default.createElement("span", null, "\u512A\u60E0\u5238"), react_1.default.createElement(CloseSquare_1.CloseSquare, {
      size: 18
    }))
  }, react_1.default.createElement(antd_1.Card, {
    title: usedCoupon.name,
    size: "small"
  }, react_1.default.createElement(CouponInfo, null, react_1.default.createElement("label", null, "\u512A\u60E0\u5238\u4EE3\u78BC"), react_1.default.createElement("h4", null, usedCoupon.code), react_1.default.createElement("label", null, "\u512A\u60E0\u5238\u6298\u6263"), react_1.default.createElement("h4", null, usedCoupon.discount), react_1.default.createElement("label", null, "\u512A\u60E0\u5238\u6D3B\u52D5\u671F\u9593"), react_1.default.createElement("h4", null, moment_1.default(usedCoupon.start_time).format('YYYY/MM/DD'), " ~", ' ', moment_1.default(usedCoupon.end_time).format('YYYY/MM/DD'))))));
}
exports.default = Coupon;
var StyledRibbonInner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"])));
var CouponInfo = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  & label {\n    display: block;\n    color: #ccc;\n  }\n\n  & h4 {\n    color: black;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  & label {\n    display: block;\n    color: #ccc;\n  }\n\n  & h4 {\n    color: black;\n  }\n"])));
var templateObject_1, templateObject_2;